document.addEventListener('DOMContentLoaded', () => {
  const openBtn = document.querySelector('.mobile-menu-open');
  const closeBtn = document.querySelector('.mobile-menu-close');
  const mobileNav = document.getElementById('MobileNav');
  const body = document.body;

  if (!openBtn || !closeBtn || !mobileNav) return;


  openBtn.addEventListener('click', (e) => {
    e.preventDefault();
    mobileNav.classList.add('is-open');
    body.style.overflow = 'hidden';
  });


  closeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    mobileNav.classList.remove('is-open');
    body.style.overflow = '';
  });


  const parentLinks = document.querySelectorAll('.mobile-parent-link');
  
  parentLinks.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      
      const item = btn.closest('.has-children');
      const submenu = item.querySelector('.mobile-submenu');
      const arrow = btn.querySelector('.arrow');

      if (submenu) {
        const isNowOpen = submenu.classList.toggle('is-open');
        
        if (arrow) {
          arrow.textContent = isNowOpen ? '−' : '+';
        }
      }
    });
  });

  document.addEventListener('click', (e) => {
    if (mobileNav.classList.contains('is-open') && 
        !mobileNav.contains(e.target) && 
        !openBtn.contains(e.target)) {
      mobileNav.classList.remove('is-open');
      body.style.overflow = '';
    }
  });
});